export default __webpack_public_path__ + "static/media/folder.eca01fe6.png";